import React from 'react'
import PropTypes from 'prop-types'
import styles from './number-input-with-stepper.scss'
import PlusIcon from 'assets/icons/ico_plus_sign.svg'
import MinusIcon from 'assets/icons/ico_minus_sign.svg'
import SvgIcon from '../SvgIcon'
import classnames from 'classnames'

const NumberInputWithStepper = ({
  label,
  value,
  onChange,
  min = 0,
  max = 10,
  step = 1,
  disabled = false,
  inputRowClassName,
  labelClassName,
  iconClassName,
  inputClassName
}) => {
  const handleMinus = () => {
    if (value > min) {
      onChange(value - step)
    }
  }

  const handlePlus = () => {
    if (value < max) {
      onChange(value + step)
    }
  }

  return (
    <div className={classnames(styles['number-input-row'], { [styles['number-input-row-disabled']]: disabled }, inputRowClassName)}>
      <span className={classnames(styles['label'], labelClassName)}>{label}</span>
      <div className={styles['stepper-wrapper']}>
        <button
          type="button"
          className={styles['stepper-btn']}
          onClick={handleMinus}
          disabled={disabled || value <= min}
        >
          <SvgIcon className={classnames(styles['stepper-icon'], iconClassName)} icon={MinusIcon} width={12} height={12} />
        </button>

        <span
          className={classnames(styles['number-display'], inputClassName)}
        >
          {value}
        </span>

        <button
          type="button"
          className={styles['stepper-btn']}
          onClick={handlePlus}
          disabled={disabled || value >= max}
        >
          <SvgIcon className={classnames(styles['stepper-icon'], iconClassName)} icon={PlusIcon} width={12} height={12} />
        </button>
      </div>
    </div>
  )
}

NumberInputWithStepper.propTypes = {
  label: PropTypes.string,
  value: PropTypes.number.isRequired,
  onChange: PropTypes.func.isRequired,
  min: PropTypes.number,
  max: PropTypes.number,
  step: PropTypes.number,
  disabled: PropTypes.bool,
  inputRowClassName: PropTypes.string,
  labelClassName: PropTypes.string,
  iconClassName: PropTypes.string,
  inputClassName: PropTypes.string
}

export default NumberInputWithStepper
